import Config from 'APP/Config'

export const REGIONS = {
  CANADA: 'CA',
}

export const isCanada = () => Config.REGION === REGIONS.CANADA
